var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"message":_vm.message,"border":false}},[_c('div',{class:_vm.$style.main},[_c('div',{class:_vm.$style.content},[_vm._v(" "+_vm._s(_vm.message.content)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }